module.exports = __webpack_public_path__ + "static/media/2013-dritter-dan-bernd.9a001507.jpg";